export class TransitionModel {
    public ID?: number;
    public UID?: number;
    public Username?: string;
    public Status?: number;
    public TransactionCode?: string;
    public OrderCodeID?: number;
    public OrderID?: number;
    public PackageType?: number;
    public Weight?: number;
    public Length?: number;
    public Width?: number;
    public Height?: number;
    public Volume?: number;
    public NumberOfPack?: number;
    public numberOfPack?: number;
    public WeightByVolume?: number;
    public FeeWeight?: number;
    public FeeShipType?: number;
    public OrderNote?: string;
    public StoreVNNote?: string;
    public RealNumberOfPack?: number;
    public StoreCNImportDate?: string;
    public StoreCNExportDate?: string;
    public StoreVNImportDate?: string;
    public StoreVNExportDate?: string;
    public ProductName?: string;
    public ProductImage?: string;
    public CreatedDate?: string;
    public statusDetail?: any;
  }  
export class SummaryTransitionModel {
    public TotalStatusAll!: number;
    public TotalStatus1!: number;
    public TotalStatus2!: number;
    public TotalStatus3!: number;
    public TotalStatus4!: number;
    public TotalStatus5!: number;
    public TotalStatus6!: number;
  }